import type { BusinessSettingsModel } from '@/shared/generated'

import { useTranslation } from 'react-i18next'

import { BusinessSettingsView } from '@/widgets/scenario-business'

import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/shared/components/ui/card'

export function ScenarioBusinessSettingsCard({
	settings,
}: {
	settings?: BusinessSettingsModel
}) {
	const { t } = useTranslation()

	if (!settings) return null

	return (
		<Card className='shadow-none'>
			<CardHeader>
				<CardTitle>{t('settings.business.long')}</CardTitle>
			</CardHeader>
			<CardContent>
				<BusinessSettingsView
					settings={settings}
					className='flex flex-col gap-2'
				/>
			</CardContent>
		</Card>
	)
}
